/**
 * ブランド情報の一元管理。
 * サイト名・コピー・メタ情報を変更する場合はこのファイルだけを更新すればよい。
 * 将来の外部サーバー移行時も、表示側はこの定数を参照するため差分を小さく保てる。
 */
export const BRAND = {
  name: "ユメサーチ",
  nameEn: "YUME SEARCH",
  tagline: "まだ知らない『好き』に、出会おう。",
  subcopy: "豊富な作品を、ランキングと詳細検索からスマートに発見。",
  concept:
    "動画・漫画・電子書籍などのデジタル作品を、検索・比較・発見できる作品検索プラットフォームです。",
  description:
    "ユメサーチは、動画・漫画・電子書籍などのデジタル作品をランキング・レビュー・詳細検索から探せる作品検索プラットフォームです。男性向け・女性向けを切り替えて、好みの作品をすぐに見つけられます。",
  keywords: "ユメサーチ,YUME SEARCH,作品検索,動画,漫画,電子書籍,ランキング,レビュー,比較",
  copyright: "© 2026 ユメサーチ",
} as const;

export const SITE_TITLE = `${BRAND.name}｜動画・漫画・電子書籍の検索・比較・ランキング`;

/** 下層ページ用のタイトル生成。例：pageTitle("ランキング") */
export function pageTitle(page: string): string {
  return `${page}｜${BRAND.name}`;
}